import { Skeleton } from '@mui/material'
import { AppTypography, ProfileInfoCardWithLinks, profilelink } from 'components'
import { ApiQueryKeys, CompanyDetailsElements, SideBarType } from 'globals/constants'
import { getMDYFormattedDate } from 'globals/functions'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useState } from 'react'
import { scroller } from 'react-scroll'
import { CrmCompaniesApi, CrmCompanyViewModel, ProfileImagePayload } from 'sdk'
interface Props {
  company: CrmCompanyViewModel | undefined
  isGetting: boolean
}
export const CrmCompanyDetailSideBar: FC<Props> = ({ company, isGetting }) => {
  const { enqueueSnackbar } = useSnackbar()
  const companyApi = new CrmCompaniesApi()
  const data: profilelink[] = [
    {
      id: 'Company',
      name: 'Company',
      icon: 'carbon:user-avatar',
      linkTo: CompanyDetailsElements.COMPANY_DETAILS,
    },
    {
      name: 'Contacts',
      icon: 'bi:people',
      id: 'Contacts',
      linkTo: CompanyDetailsElements.LINKED_CONTACTS,
    },
    {
      name: 'Notes',
      icon: 'ph:question',
      id: 'Notes',
      linkTo: CompanyDetailsElements.LINKED_NOTES,
    },
  ]
  const [image, setImage] = useState<string | null>()
  const handleImageSave = (imageSrc: string) => {
    setImage(imageSrc)
    enqueueSnackbar('Company image updated successfully', { variant: 'success' })
  }
  const handleRemoveImage = () => {
    setImage(null)
    enqueueSnackbar('Company image removed successfully', { variant: 'success' })
  }
  useEffect(() => {
    setImage(company?.LogoUrl)
  }, [company])

  return (
    <ProfileInfoCardWithLinks
      isProfilePictureLoading={isGetting}
      links={data}
      sideBarType={SideBarType.CRMContact}
      onLinkClick={(link) => {
        scroller.scrollTo(link.linkTo!, {
          duration: 800,
          delay: 0,
          smooth: true,
          offset: -50,
        })
      }}
      principalId={company?.Id!}
      imageSrc={image}
      defaultImage="/images/default-crm-company.png"
      onImageSave={handleImageSave}
      uploadImageFn={(data: ProfileImagePayload) => companyApi.uploadCompanyLogo(data)}
      uploadImageFnKey={ApiQueryKeys.crm.companies.UploadPicture}
      removeImageFn={() => companyApi.deleteCompanyLogo(company?.Id!)}
      removeImageFnKey={ApiQueryKeys.crm.companies.RemovePicture}
      onRemoveImage={handleRemoveImage}
      contentInfo={
        <>
          {isGetting ? (
            <>
              <Skeleton height={40} width={150} />
              <Skeleton height={30} width={100} />
            </>
          ) : (
            <>
              <AppTypography fontWeight={700} fontSize={18}>
                {company?.Name ?? ''}
              </AppTypography>
              {company?.Phone && <AppTypography color={'grey.800'}>{company?.Phone}</AppTypography>}
              {company?.Modified && (
                <AppTypography color={'grey.800'}>{getMDYFormattedDate(new Date(company?.Modified))}</AppTypography>
              )}
            </>
          )}
        </>
      }
    />
  )
}
